import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=07853fdf&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07853fdf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07853fdf')) {
      api.createRecord('07853fdf', component.options)
    } else {
      api.reload('07853fdf', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=07853fdf&scoped=true&", function () {
      api.rerender('07853fdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QzbTU8pD2gYL/JS/comp/Accordion.vue"
export default component.exports